export default function chooseVariation(){

	let fakeForm = jQuery('#shop-form')
	jQuery(fakeForm).on('change', function(){
		let listedAttributes = [];
		jQuery(this).find("input[name^='attribute_']").each(function() {

			let attributeName = jQuery(this).attr('name')
			jQuery('input[name=radio_for_' + String(attributeName) + ']').each(function(){
				if (jQuery(this).prop('checked')) {
					let selected = jQuery(this).val()
					let attr = {name: attributeName, value: selected}
					listedAttributes.push(attr)
				}
			})
		})

		let form = jQuery('.variations_form')
		for (let i=0; i<listedAttributes.length; i++){
			form.find('select[name=' + listedAttributes[i].name + ']').val(listedAttributes[i].value)
			form.find('select[name=' + listedAttributes[i].name + ']').change()
		}
	})

	fakeForm.change();
}
